import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

//set Default Language
const DEFAULT_LANG = 'de'

const locales = {
  de: {},
  en: {},
}
const i18n = new VueI18n({
  locale    : DEFAULT_LANG,
  messages  : locales,
})

export default i18n
